import {makeAutoObservable, toJS} from "mobx";

class TimeStore {

    timeData = [];
    reservedTime = null;
    constructor() {
        makeAutoObservable(this)
    }

    setTimeData(arr) {
        this.timeData = [...arr];
    }

    getTime(){
        return toJS(this.timeData);
    }

    setReservedTime(data){
        this.reservedTime = data
    }
    getReservedTime(){
        return this.reservedTime;
    }

    delTimeData() {
        this.timeData = [];
    }

    initValue() {
        this.timeData = [];
    }
}

let timeStore = new TimeStore()

export default timeStore